var Handlebars = require("handlebars/runtime");
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<span id=\"header_buttons\"></span><i class=\"icon-spinner icon-spin detail-view-busy-spinner\"></i><span id=\"pairing_status\"></span>\n";
},"useData":true});